// extracted by mini-css-extract-plugin
export var highlightFade = "_3m-4";
export var highlighted = "_3m-3";
export var table = "_3m-1";
export var tableContainer = "_3m-0";
export var totalsRow = "_3m-2";